"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackPageView } from "./firebase";
import { useConsent } from "./ConsentProvider";

/**
 * Fires a Firebase Analytics `page_view` whenever the route changes, but only
 * once the visitor has granted analytics consent (see `ConsentProvider`).
 * Mounted once in the root layout so every page (main site + pilot portal) is
 * covered, and re-fires immediately when consent is granted mid-session so
 * the current page isn't missed.
 *
 * Deliberately avoids `useSearchParams` (which would require a Suspense
 * boundary in the App Router) since query strings aren't needed for basic
 * page-view tracking here.
 */
export function FirebaseAnalyticsListener() {
  const pathname = usePathname();
  const { status } = useConsent();

  useEffect(() => {
    if (status !== "granted") return;
    trackPageView(pathname);
  }, [pathname, status]);

  return null;
}
